import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=68dd1bdf&scoped=true&"
import script from "./Gauge.vue?vue&type=script&lang=js&"
export * from "./Gauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd1bdf",
  null
  
)

export default component.exports